import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";

import { CommonModule } from "@angular/common";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { COOKIE_PREFIX } from "src/environments/environment";
import { API_URLS, EMAIL_PATTERN } from "../../../config/app.constants";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    CommonModule,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  submitted: boolean = false;
  isForgot: boolean = false;

  userDetails: FormGroup;
  email = new FormControl("", [
    Validators.required,
    Validators.pattern(EMAIL_PATTERN),
  ]);

  constructor(
    private http: HttpinterceptorService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    const token = localStorage.getItem(`${COOKIE_PREFIX}_token`);
    if (token) {
      this.router.navigate(["/"]);
    }
  }

  ngOnInit() {
    this.initLoginForm();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout(() => {
      window.scroll(100, 100);
    }, 0);
  }
  initLoginForm() {
    this.userDetails = this.formBuilder.group({
      email: this.email,
    });
  }

  forgotUser() {
    this.submitted = true;
    if (this.userDetails.valid) {
      this.isForgot = true;
      this.http
        .post(API_URLS.FORGOT_USER, this.userDetails.value, true)
        .subscribe(
          (res) => {
            this.submitted = false;
            this.isForgot = false;
            if (res.code == 200 && res.type === "success") {
              this.userDetails.reset();
              this.router.navigate(["/"]);
            }
          },
          (error) => {
            this.submitted = false;
            this.isForgot = false;
          }
        );
    } else {
      return false;
    }
  }

  cancelForgotPassword() {
    this.router.navigate(["/login"]);
  }
}
